class Rules {
  constructor() { }

  findGroup(country, hasResidency) {
    var isEu = App.eu[country] != null;
    var isNorden = App.norden[country] != null;

    if(hasResidency || isNorden) {
      return "UIOMASTER";
    } else {
       if(isEu) {
         return "EUMAS";
       } else {
         return "SFMASTER";
       }
    }
  }

  findGroupWithoutResidency(country) {
    var isEu = App.eu[country] != null;
    var isNorden = App.norden[country] != null;

    if(isNorden) {
      return "UIOMASTER";
    } else {
       if(isEu) {
         return "EUMAS";
       } else {
         return "SFMASTER";
       }
    }
  }

  showSpecialPriceRule(group, country) {
    if(App.program.programCode === "MFM2-EMHEM") {
      return this.findGroupWithoutResidency(country);
    } else {
      return group;
    }
  }
  showSpecialTuitionRule(group, country, hasResidency) {
    var isEu = App.eu[country] != null;
    var exceptions = ["MFM2-EMHEM", "SVM2-MINDS", "HFM2-VMNS", "HFM2-EUH", "TFM2-RRE"];
    if(!isEu && exceptions.indexOf(App.program.programCode) === -1) {
      return true;
    }
    return false;
  }
  showIdentification(hasResidency) { return !hasResidency || App.program.programCode === "MFM2-EMHEM";           }
  showFinancing(group)             { return group === "SFMASTER";                                                }
  showFinancingExtraEMHEM(group)   { return App.program.programCode === "MFM2-EMHEM"                             }
  showDeadlineTranscripts(group)   { return group === "UIOMASTER" || group === "EUMAS" || group === "SFMASTER";  }
  showCutOff(group) {
    var isSFMASTERNorwegianNotDualLanguage = group === "SFMASTER" && App.lang != "en" && App.program.fellestekst["opptak-master-sprakkrav"] != "master-opptak-sprak-tospraklig";

    var exceptions = Fellestekst("studiet-master-cutoff", "studiet-master-cutoff-codes-SFMASTER", "no").replace(/\s/igm, "").replace("<p>","").replace("</p>", "").split(",");
    var isSFMASTERExceptions = exceptions.indexOf(App.program.programCode) !== -1 && group === "SFMASTER";
    return isSFMASTERNorwegianNotDualLanguage || isSFMASTERExceptions;
  }
  showPartTime() {
    return App.program.programCode === "UVM2-MAE";
  }

}

export default new Rules;
